import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import MainLayout from './MainLayout';
import EventSystemDataPreloader from '../eventSystem/EventSystemDataPreloader';
import EventSystemLayout from '@libs/components/EventSystemLayout';
import { Box, Paper, Tabs, Tab } from '@mui/material';

// Icons for tabs
const FlowIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M12.586 4.586a2 2 0 112.828 2.828l-3 3a2 2 0 01-2.828 0 1 1 0 00-1.414 1.414 4 4 0 005.656 0l3-3a4 4 0 00-5.656-5.656l-1.5 1.5a1 1 0 101.414 1.414l1.5-1.5zm-5 5a2 2 0 012.828 0 1 1 0 101.414-1.414 4 4 0 00-5.656 0l-3 3a4 4 0 105.656 5.656l1.5-1.5a1 1 0 10-1.414-1.414l-1.5 1.5a2 2 0 11-2.828-2.828l3-3z" clipRule="evenodd" />
  </svg>
);

const ConfigWorkspaceIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM13 20.91V19h-2v1.91c-3.79-.47-6.72-3.4-7.19-7.19H5v-2H2.81c.47-3.79 3.4-6.72 7.19-7.19V5h2V2.81c3.79.47 6.72 3.4 7.19 7.19H19v2h2.19c-.47 3.79-3.4 6.72-7.19 7.19zM12 15a3 3 0 100-6 3 3 0 000 6z" />
  </svg>
);

const SipIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-3.28a1 1 0 01-.948-.684l-1.498-4.493a1 1 0 01.502-1.21l2.257-1.13a11.042 11.042 0 00-5.516-5.516l-1.13 2.257a1 1 0 01-1.21.502L5.684 4.28A1 1 0 015 3z" />
  </svg>
);

const SipInterworkingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
  </svg>
);

const LogIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
  </svg>
);

const InboundRuleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
  </svg>
);

const IncomingEventsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
  </svg>
);

const ActionsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
    <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
  </svg>
);

const SimpleActionsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
  </svg>
);

const CallRoutingIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M2 4a2 2 0 012-2h4a2 2 0 012 2v1a2 2 0 01-.586 1.414L8.12 7.707a9.01 9.01 0 004.172 4.172l1.293-1.293A2 2 0 0115 10h1a2 2 0 012 2v4a2 2 0 01-2 2h-1C8.373 18 2 11.627 2 4V4z" clipRule="evenodd" />
  </svg>
);

/**
 * EventSystemTabLayout - A unified layout for Event System pages
 * Uses the Admin Console sidebar from MainLayout and adds top tabs for Event System sections
 */
const EventSystemTabLayout = ({ children, pageTitle, showPageTitle = true }) => {
  const location = useLocation();

  // Define the navigation tabs for the Event System
  const tabItems = [
    { path: '/admin/event-system/flows', label: 'Flows', icon: <FlowIcon /> },
    { path: '/admin/event-system/actions', label: 'Actions', icon: <ActionsIcon /> },
    { path: '/admin/event-system/simple-actions', label: 'Paging', icon: <SimpleActionsIcon /> },
    { path: '/admin/event-system/inbound-rules', label: 'Triggers', icon: <InboundRuleIcon /> },
    { path: '/admin/event-system/scheduled', label: 'Scheduled', icon: <IncomingEventsIcon /> },
    { path: '/admin/event-system/call-routing', label: 'Call Routing', icon: <CallRoutingIcon /> },
  ];

  return (
    <MainLayout>
      {/* Invisible component that preloads all Event System data */}
      <EventSystemDataPreloader />
      
      <EventSystemLayout pageTitle={pageTitle} showPageTitle={showPageTitle}>
        {/* Navigation tabs */}
        <Box sx={{ mb: 1 }}>
          <Tabs
            value={tabItems.some(t => t.path === location.pathname) ? location.pathname : false}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
          >
            {tabItems.map((item) => (
              <Tab
                key={item.path}
                value={item.path}
                label={item.label}
                icon={item.icon}
                iconPosition="start"
                component={Link}
                to={item.path}
              />
            ))}
          </Tabs>
        </Box>

        {/* Page content */}
        <Paper elevation={1} sx={{ p: 0, overflow: 'auto', maxHeight: 'calc(100vh - 220px)' }}>
          {children}
        </Paper>
      </EventSystemLayout>
    </MainLayout>
  );
};

export default EventSystemTabLayout;
